import axios from 'axios';
import ImportValidator from './ImportValidator';

class APIClient {
  constructor() {
    const service = axios.create();
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
    this.organization = this.getOrganization();
    this.basePath = this.organization === 'CA' ? process.env.REACT_APP_API_URL_CA : process.env.REACT_APP_API_URL;
  }

  getOrganization = () => {
    const container = document.getElementsByTagName('PingNationDashboard')[0];
    const organization = ImportValidator.validateOrganization(container.getAttribute('organization'));
    return organization;
  };

  handleSuccess = (response) => {
    return response;
  }

  handleError = (error) => {
    return Promise.reject(error);
  }

  get(path, callback) {
    return this.service.get(`${this.basePath}${path}`).then(
      (response) => callback(response.status, response.data),
    );
  }

  patch(path, payload, callback) {
    return this.service.request({
      method: 'PATCH',
      url: `${this.basePath}${path}`,
      responseType: 'json',
      data: payload,
    }).then((response) => callback(response.status, response.data));
  }

  post(path, payload, callback) {
    return this.service.request({
      method: 'POST',
      url: `${this.basePath}${path}`,
      responseType: 'json',
      data: payload,
    }).then((response) => callback(response.status, response.data));
  }
}

export default new APIClient();
